import {useEffect, useState} from "react";
import {BillingPanelTableData, TotalsData} from "../../types";
import BillingPanelService from "../../billingPanel/service/BillingPanelService";
import SignaturesService from "./service/SignaturesService";
import {ca} from "date-fns/locale";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import {Container} from "../../styles";
import {T2} from "../../../../styles/titles";
import {FormFilter} from "./components/filter/filters";
import useGetMe from "../../../../hooks/useCurrentUser";
import {LiveTable} from "./components/liveTable";

const Signatures: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState<BillingPanelTableData | null>(null);
  const [pageSize, setPageSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const signatureService = new SignaturesService();
  const [filterData, setFilterData] = useState<any>(null);
  const user = useGetMe();


  const fetchData = async () => {
    setIsLoading(true);
    try {
      const data = await signatureService.getSignatures(
        currentPage,
        pageSize,
        filterData);
      setTableData({
        records: data.records || [],
        count: data.rowCount || 0,
      });
    } catch (error) {
      console.error("Erro ao buscar nos dados: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (filterData) {
      fetchData();
    }
  }, [filterData, currentPage, pageSize]);

  const handleSaveChanges = async (signatures: Array<{id: number, values: {payed: boolean, merchantId: string, totalPending: number}}>) => {
    setIsLoading(true);
    try {
      await signatureService.savePayments(signatures);
      await fetchData();
    } catch (error) {
      console.error("Erro ao salvar pagamentos: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <LoadingOverlay
        show={isLoading}
        relative
      />

      <T2>Produtos Contratados</T2>
      <FormFilter getFilters={(data => setFilterData(data))}/>
      {tableData && <LiveTable
        data={tableData}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={setCurrentPage}
        onPageSizeChange={setPageSize}
        onSaveChanges={handleSaveChanges}
      />}
    </Container>
  )
}

export default Signatures;
